<template>
  <div class="heroes-side-picks-hero" :class="classes">
    <Hero v-if="hero" :hero="hero" class="heroes-side-picks-hero__hero" />
    <div v-else class="heroes-side-picks-hero__default">?</div>
  </div>
</template>

<script>
import Hero from "./Hero";

export default {
  name: "HeroesSidePicksHero",
  components: {
    Hero
  },
  props: {
    hero: Object,
    left: Boolean,
    right: Boolean
  },
  computed: {
    classes() {
      return {
        "heroes-side-picks-hero_left": this.left,
        "heroes-side-picks-hero_right": this.right
      };
    }
  }
};
</script>

<style lang="scss">
$p: ".heroes-side-picks-hero";

.heroes-side-picks-hero {
  &:not(:last-child) {
    margin-bottom: 18px;
  }

  &__default {
    border: 2px solid transparent;
    font-size: 34px;
    text-align: center;
    font-family: "Montserrat";
    font-weight: bold;
    line-height: 34px;
  }

  &__default,
  &__hero {
    width: 66px;
    height: 38px;
  }

  &_left {
    #{$p}__default,
    #{$p}__hero {
      border-color: #e72f31;
    }
    #{$p}__default {
      background: #680b0c;
      color: #ed3e3d;
    }
  }

  &_right {
    #{$p}__default,
    #{$p}__hero {
      border-color: #1480b2;
    }
    #{$p}__default {
      background: #0d5577;
      color: #3cabdd;
    }
  }

  @include breakpoint("md-and-down") {
    &:not(:last-child) {
      margin-bottom: 0;
      margin-right: 18px;
    }
  }
}
</style>
